<template>

  <svg
    t="1639130612954"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3985"
    width="64"
    height="64"
  ><path d="M116.4921875 116.4921875l0 186.12132317 791.015625 0 0-186.12132317-791.015625 0zM860.9774817 256.08317987l-697.9549634 0 0-93.06066158 697.95496341 0 0 93.06066158zM116.4921875 581.79549619l791.015625 0 0-186.12132317-791.015625 0 0 186.12132317zM163.0225183 442.20450381l697.9549634 0 0 93.06066158-697.95496341 0 0-93.06066158zM116.4921875 860.9774817l791.015625 1e-8 0-186.12132317-791.015625 0 0 186.12132317zM163.0225183 721.38648933l697.9549634 0 0 93.0606616-697.95496341 0 0-93.0606616z" p-id="3986" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconViewList',
} as DefineComponent
</script>